import React from "react"
import EpisodePlayer from "../../../components/EpisodePlayer"
import { Column, Container, Row } from "../../../components/Grid"
import Hero from "../../../components/Hero"
import Layout from "../../../components/Layout"
import Resource from "../../../components/Resource"
import Section from "../../../components/Section"
import SEO from "../../../components/Seo"

const PharmacyCareersESPage = ({ location }) => {
  const queryParameters = new URLSearchParams(location.search)
  const keyIndex = queryParameters.get("keyIndex")
  let [key, index] = keyIndex ? keyIndex.split("_") : ""
  index = Number.parseInt(index)
  return (
    <Layout className="pharmacy-careers">
      <SEO title="Pharmacy Careers" />
      {/***************  HERO ***************/}
      <Section className="hero hero--pharmacy-careers">
        <Hero
          title="Descubrir carreras"
          infographic="img-hero-pharmacy-careers.png"
          body="¿Cuál es la labor de un farmacéutico?  Conoce cómo obtener el título de Doctor en Farmacia (PharmD) para convertirte en farmacéutico y de qué manera estos profesionales promueven la salud y el bienestar en las comunidades donde ejercen su profesión."
          image="img-hero-pharm-careers.png"
        />
      </Section>

      <Section className="midgray-background">
        <Container fullWidth>
          <Row>
            <h2 style={{ color: "#0B315E", fontSize: "32px" }}>
              Videos: perfiles profesionales en farmacia
            </h2>
            <p>
              Las oportunidades para los farmacéuticos son muy variadas y
              permiten trabajar con un profundo sentido de propósito al servicio
              de la comunidad. Es una labor gratificante y de gran
              responsabilidad que contribuye directamente a la salud y el
              bienestar de quienes te rodean.
            </p>
            <EpisodePlayer
              style={{ padding: "0 1rem 2rem" }}
              playerLabelTitle=""
              presetVideo={key === "career-profiles"}
              presetVideoIndex={index}
              episodes={[
                {
                  title: "Maria Gil-Flores",
                  videoDuration: "3:43 min",
                  guidSrc: "22f0ce83-1ebc-40ee-9897-64dbd98e029f",
                  personDescription:
                    "María Gil-Flores, farmacéutica de cuarta generación, habla sobre su labor y su liderazgo en el ámbito de la farmacia. ",
                  listImage: "pharmacy-careers-maria-thumbnail.png",
                  listDescription:
                    "María Gil-Flores, farmacéutica de cuarta generación, habla sobre su labor y su liderazgo en el ámbito de la farmacia. ",
                },
                {
                  title: "Jaimin Patel",
                  videoDuration: "2:07 min",
                  personDescription:
                    "Jaimin relata su trayectoria por distintas opciones profesionales en farmacia, posibles gracias a su título de Doctor en Farmacia (PharmD). ",
                  guidSrc: "f5cb8c31-41df-4741-b097-19504a9921ed",
                  listImage: "pharmacy-careers-jaimin-patel-thumbnail.png",
                  listDescription:
                    "Jaimin relata su trayectoria por distintas opciones profesionales en farmacia, posibles gracias a su título de Doctor en Farmacia (PharmD). ",
                },
              ]}
            />
          </Row>
        </Container>
      </Section>

      <Section className="midgray-background">
        <Container>
          <Row>
            <Column span={12}>
              <h2 style={{ color: "#0B315E", fontSize: "32px" }}>
                Perfiles profesionales
              </h2>
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="TÉCNICO EN FARMACIA"
                image="CVS-Pharma-CareerProfile-PharmacyTechnician.jpg"
                title="El trabajo en equipo con farmacéuticos "
                description={
                  <p className="mt-2 mb-2">
                    En la farmacia comunitaria, el técnico en farmacia cumple un
                    papel clave: gestiona recetas, dispensa medicamentos,
                    mantiene el inventario al día, colabora en la atención de
                    consultas y en diversas tareas del servicio.
                  </p>
                }
                actions={[
                  {
                    label: "Perfil profesional",
                    path:
                      "/docs/CVS-Pharma-CareerProfile-PharmacyTechnician_ES.pdf",
                    type: "download",
                    locked: false,
                  },
                ]}
                horizontal
              />
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="FARMACÉUTICO COMUNITARIO"
                image="CVS-Pharma-CareerProfile-Pharmacist.jpg"
                title="Servicio e impacto en la comunidad"
                description={
                  <p className="mt-2 mb-2">
                    Los farmacéuticos comunitarios son los profesionales de la
                    salud más accesibles. Contribuyen al bienestar de la
                    comunidad mediante la dispensación de medicamentos, la
                    prestación de servicios de salud, la educación al paciente y
                    su acompañamiento y representación, entre otras funciones.
                  </p>
                }
                actions={[
                  {
                    label: "Perfil profesional",
                    path:
                      "/docs/CVS-Pharma-CareerProfile-CommunityPharmacist_ES.pdf",
                    type: "download",
                    locked: false,
                  },
                ]}
                horizontal
              />
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="Líder empresarial"
                image="CVS-Pharma-CareerProfile-PharmacyBusinessLeader.jpg"
                title="Excelencia en salud a mayor escala"
                description={
                  <p className="mt-2 mb-2">
                    Los líderes empresariales multiplican el impacto en la
                    comunidad al coordinar y mejorar el desempeño de varias
                    farmacias en una región. Capacitan y desarrollan a los
                    equipos para brindar atención de calidad a los pacientes, a
                    la vez que administran las operaciones del negocio.
                  </p>
                }
                actions={[
                  {
                    label: "Perfil profesional",
                    path:
                      "/docs/CVS-CareerProfile-PharmacyBusinessLeader_ES.pdf",
                    type: "download",
                    locked: false,
                  },
                ]}
                horizontal
              />
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="Gerente de operaciones de farmacia"
                image="CVS-Pharma-CareerProfile-PharmacyOperationsManager.jpg"
                title="La salud, desde todos los frentes"
                description={
                  <p className="mt-2 mb-2">
                    El gerente de operaciones de farmacia está en el centro de
                    la operación: aplica su experiencia farmacéutica para
                    potenciar el desempeño y los resultados de toda la cadena de
                    farmacias.
                  </p>
                }
                actions={[
                  {
                    label: "Perfil profesional",
                    path:
                      "/docs/CVS-CareerProfile-PharmacyOperationsManager_ES.pdf",
                    type: "download",
                    locked: false,
                  },
                ]}
                horizontal
              />
              <Resource
                resourceContainerClass="pl-0 pr-0"
                halfLabel
                label="Especializaciones"
                image="CVS-Pharma-CareerProfile-SpecializedPharmacyCareerPathways.jpg"
                title="Orienta tu carrera"
                description={
                  <p className="mt-2 mb-2">
                    Si te interesa brindar atención domiciliaria o trabajar en
                    cuidados de larga duración, o bien optimizar los servicios
                    de farmacia por correo, existe un sinfín de opciones de
                    especialización para los farmacéuticos.
                  </p>
                }
                actions={[
                  {
                    label: "Perfil profesional",
                    path: "/docs/CVS-CareerProfile-SpecializedPharmacy_ES.pdf",
                    type: "download",
                    locked: false,
                  },
                ]}
                horizontal
              />
            </Column>
          </Row>
        </Container>
      </Section>
    </Layout>
  )
}
export default PharmacyCareersESPage
